import { FormControl, Grid, InputAdornment } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DatePickerComponent from "../common/date.picker.component";
import InputFilterFieldStyled from "../styled/input.filter.field.styled";
import InputLabelStyled from "../styled/input.label.styled";
import { ReactComponent as ShekelIcon } from "../../assets/icons/shekel-icon.svg";
import moment from "moment";
import digitalWalletStore from "@/stores/digital.wallet.store";

interface IBulkWalletsUpdateStepTwo { }

const BulkWalletsUpdateStepTwo: FC<IBulkWalletsUpdateStepTwo> = () => {
    const { t } = useTranslation();
    const request = digitalWalletStore.bulkUpdateDigitalWalletsRequest;
    const [expiredDate, setExpiredDate] = useState<Moment | null>(null);
    const [amount, setAmount] = useState<number | string>('');

    const updateDate = (date: Moment | null) => {
        const formattedDate = date?.format("YYYY-MM-DD");
        setExpiredDate(date);
        digitalWalletStore.setBulkUpdateDigitalWalletsRequest({
            ...request,
            expiredDate: formattedDate,
        });
    };

    function onChangeEvent(evt: string) {
        const newValue = evt;
        if (/^-?[0-9\b]+$/.test(newValue) || newValue === '' || newValue === '-') {
            setAmount(newValue);
            const newAmount = Number(newValue) || 0;
            digitalWalletStore.setBulkUpdateDigitalWalletsRequest({
                ...request,
                amount: newAmount,
            });
        }
    }

    useEffect(() => {
        if (!request.amount) {
            setAmount('');
        } else {
            setAmount(Number(request.amount));
        }

        if (request.expiredDate) {
            const expDate = moment(request.expiredDate, "YYYY-MM-DD");
            setExpiredDate(expDate);
        }
    }, []);
    return (
        <Grid className="bulk-update-steps-content">
            <Grid className="bulk-update-steps-title">{t("digitalWallet.BulkWalletsUpdate")}</Grid>
            <Grid className="bulk-update-step-two-content">
                <Grid hidden={request.type === 3}>
                    <Grid sx={{ marginBottom: "7px" }}>
                        <InputLabelStyled shrink disableAnimation size="normal">
                            {t("digitalWallet.AmountToLoadForEachEmployee")}
                        </InputLabelStyled>
                    </Grid>
                    <Grid>
                        <FormControl variant="standard" sx={{ width: "70%" }}>
                            <InputFilterFieldStyled
                                id="bulk-update-wallet-amount"
                                type="text"
                                size="small"
                                value={amount}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <ShekelIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(event) => {
                                    onChangeEvent(event.target.value);
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid hidden={request.type === 1}>
                    <Grid sx={{ marginBottom: "7px", marginTop: "15px" }}>
                        <InputLabelStyled shrink disableAnimation size="normal">
                            {t("digitalWallet.NewWalletExpirationDate")}
                        </InputLabelStyled>
                    </Grid>
                    <Grid>
                        <FormControl variant="standard" sx={{ width: "70%" }}>
                            <DatePickerComponent
                                title=""
                                value={expiredDate}
                                minDate={moment()}
                                updateDate={updateDate}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BulkWalletsUpdateStepTwo;
